import { Box, Button, HStack, IconButton, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text, VStack } from "@chakra-ui/react";
import { Close } from "@mui/icons-material";
import React from "react";
import apiClient from "../../clients/apiClient.js";
import {NewAndExistingMembers} from "./CreateGroupModal";


const EditGroupModal = ({ isModalOpen, onClose, groupToEdit, teamMembers, editGroup }) => {
    return (
        <Modal
            isOpen={isModalOpen}
            onClose={onClose}
            isCentered
            size="lg"
            motionPreset="slideInBottom"
        >
            <ModalOverlay
                bg="blackAlpha.300"
                backdropFilter="blur(1px)"
            />
            <GroupModal onClose={onClose} groupToEdit={groupToEdit} teamMembers={teamMembers} editGroupInTab={editGroup}/>
        </Modal>
    );
}

const GroupModal = ({ onClose, groupToEdit, teamMembers, editGroupInTab }) => {
    const [groupName, setGroupName] = React.useState("");
    const [description, setDescription] = React.useState("");
    const [groupMembers, setGroupMembers] = React.useState([]);
    const [nonGroupMembers, setNonGroupMembers] = React.useState(teamMembers);
    const [searchValue, setSearchValue] = React.useState("");
    const [filteredMembers, setFilteredMembers] = React.useState([]);

    // React.useEffect(() => {
    //     let tempGroupMembers = filterValidGroupMembers(groupMembers)
    //     calculateNonGroupMembers(tempGroupMembers);
    //     setGroupMembers(tempGroupMembers);
    // }, [teamMembers]);

    console.log("nonGroupMembers", nonGroupMembers);

    React.useEffect(() => {
        if (groupToEdit) {
            setGroupName(groupToEdit.name);
            setDescription(groupToEdit.description);
            setGroupMembers(groupToEdit.members);
            let tempNonGroupMembers = teamMembers.filter(member => 
                !groupToEdit.members.some(groupMember => groupMember.email === member.email)
            );
            setNonGroupMembers(tempNonGroupMembers);
        } else {
            setGroupName("");
            setDescription("");
            setGroupMembers([]);
            setNonGroupMembers(teamMembers);
        }
    }, [groupToEdit]);

    const filterValidGroupMembers = (members) => {
        return members.filter(member => {
            return teamMembers.some(teamMember => {
                return teamMember.first_name === member.first_name && teamMember.last_name === member.last_name;
            });
        });
    }

    const calculateNonGroupMembers = (existingMembers) => {
        const nonGroupMembers = teamMembers.filter(member => 
            !existingMembers.some(existingMember => existingMember.email === member.email)
        );
        setNonGroupMembers(nonGroupMembers);
    }

    const isEditValid = () => {
        if (groupMembers.length < 2) {
            return false;
        }

        if (groupName == "" ) {
            return false;
        }

        if (description != "" && description != groupToEdit.description) {
            return true
        }

        if (groupMembers.length != groupToEdit.members.length) {
            return true
        }

        for (let i = 0; i < groupMembers.length; i++) {
            if (!groupToEdit.members.some(member => member.email === groupMembers[i].email)) {
                return true;
            }
        }

        return false
    }

    const editGroup = () => {
        if (!isEditValid()) {
            return;
        }

        let newMembers = groupMembers.filter(member => {
            return !groupToEdit.members.some(teamMember => {
                return teamMember.email === member.email;
            });
        });

        let removedMembers = groupToEdit.members.filter(member => {
            return !groupMembers.some(groupMember => {
                return groupMember.email === member.email;
            });
        });

        let newName = groupName != groupToEdit.name ? groupName : null;
        let newDescription = description != groupToEdit.description ? description : null;

        apiClient.post('/account-settings/group-actions', {
            action: "edit_group",
            edit_group: {
                id: groupToEdit.id,
                new_name: newName,
                new_desc: newDescription,
                add_members: newMembers.map(member => ({
                    first_name: member.first_name,
                    last_name: member.last_name,
                    email: member.email
                })),
                remove_members: removedMembers.map(member => ({
                    first_name: member.first_name,
                    last_name: member.last_name,
                    email: member.email
                }))
            }
        }).then(({data}) => {
            if (data?.success != true) {
                console.error("[EditGroupModal] Error editing group", data?.message);
                return;
            }
            console.log("[EditGroupModal] Group edited successfully", data);
            editGroupInTab({
                id: groupToEdit.id,
                name: groupName,
                description: description,
                members: groupMembers.map(member => ({
                    first_name: member.first_name,
                    last_name: member.last_name,
                    email: member.email
                })),
            })
            onClose();
        })
    }

    return (
        <ModalContent>
            <ModalHeader>
                <HStack
                    justifyContent="space-between"
                    alignItems="center"
                    width="100%"
                >
                    <Text
                        justifySelf={"flex-start"}
                        fontSize="xl"
                        fontWeight="bold"
                        fontFamily={"sans-serif"}
                        color={"#1d1d1d"}
                    >Edit Group</Text>
                    <IconButton
                        justifySelf={"flex-end"}
                        sx={{ 
                            paddingX:0, 
                            paddingY:0,
                            backgroundColor:"transparent",
                            "&:hover":{backgroundColor:"transparent"}
                        }}
                        icon={
                            <Close sx={{ padding:0, fontSize: 24, color: "#5d5d5d" }}/>
                        }
                        onClick={onClose}
                    />
                </HStack>
            </ModalHeader>
            <ModalBody>
                <VStack
                    alignItems="flex-start"
                    justifyContent="flex-start"
                    width="100%"
                    spacing={0}
                >
                    <HStack
                        alignItems="center"
                        spacing={1}
                        marginBottom={"5px"}
                    >
                        <Text fontSize="14px" fontWeight={"semibold"} color="#1d1d1d" lineHeight={"22px"}>
                            Group Name
                        </Text>
                        <Text 
                            fontSize="12px" color="#7d7d7d" fontWeight={"normal"} lineHeight={"22px"}> (required)
                        </Text>
                    </HStack>
                    <Box
                        mb="4"
                        w={"65%"}
                    >
                        <Input 
                            placeholder="Group Name" 
                            size="md"
                            value={groupName}
                            onChange={(e) => setGroupName(e.target.value)}
                        />
                    </Box>
                    <Text mb="4px" fontSize="14px" fontWeight={"semibold"} color="#1d1d1d">
                        Description
                    </Text>
                    <Box
                        mb="4"
                        w={"90%"}
                    >
                        <Input 
                            placeholder="Description"
                            size="md"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </Box>
                    <NewAndExistingMembers 
                        searchValue={searchValue}
                        setSearchValue={setSearchValue}
                        filteredMembers={filteredMembers}
                        setFilteredMembers={setFilteredMembers}
                        groupMembers={groupMembers}
                        setGroupMembers={setGroupMembers}
                        nonGroupMembers={nonGroupMembers}
                        setNonGroupMembers={setNonGroupMembers}
                    />
                </VStack>
            </ModalBody>
            <ModalFooter>
                <Button
                    bgColor={"#E5E5E5"}
                    color={"#000"}
                    _hover={{ bgColor: "#E5E5E5" }}
                    onClick={onClose}
                    marginRight={"2px"}
                >
                    Discard
                </Button>
                <Button
                    bgColor={"#2584FD"}
                    color={"#fff"}
                    _hover={{ bgColor: "#2584FD" }}
                    onClick={editGroup}
                    marginLeft={"2px"}
                    isDisabled={!isEditValid()}
                >
                    Edit Group
                </Button>
            </ModalFooter>
        </ModalContent>
    );
}


export default EditGroupModal;